import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import BrandWave from '../BrandWave/BrandWave';
import { BOOKING_URL } from '../../config/links';
import './Hero.css';

const Hero = () => {
  const { t } = useTranslation();

  const handleNavigation = (path) => {
    if (path.startsWith('#')) {
      const element = document.getElementById(path.substring(1));
      if (element) {
        const offsetTop = element.offsetTop - 70;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    } else {
      window.location.href = path;
    }
  };

  return (
    <section id="home" className="hero">
      <BrandWave />
      <div className="hero-overlay" aria-hidden="true" />
      <div className="hero-container">
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <p className="hero-slogan" lang="en">
            <span>{t('hero.sloganLine1')}</span>
            <span className="hero-slogan-accent">{t('hero.sloganLine2')}</span>
          </p>
          <h1 className="hero-title">{t('hero.title')}</h1>
          <p className="hero-subtitle">{t('hero.subtitle')}</p>
          <div className="hero-buttons">
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              {t('hero.demoBtn')}
            </a>
            <button
              className="btn btn-secondary"
              onClick={() => handleNavigation('/contact')}
            >
              {t('hero.contactBtn')}
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
